export interface HiddenCountRowProps {
  /** t('ec2.group.hidden.title', {count}) — `3 hidden quests are out there`. */
  title: string;
  /** t('ec2.group.hidden.caption') — `Scan QRs around the venue to reveal them`. */
  caption: string;
  /** Opens the scanner. */
  onClick: () => void;
  className?: string;
}

/**
 * The count-only dashed row for a group's hidden members (Concept A, mystery
 * dialect): dashed `?` chip + count text. NEVER one fake row per hidden quest —
 * titles would leak hints. Tapping opens the scanner.
 */
export function HiddenCountRow({ title, caption, onClick, className = '' }: HiddenCountRowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="ec-hidden-count-row"
      className={
        `flex min-h-[52px] w-full items-center gap-2.5 px-4 py-2 text-left ` +
        `border-t border-border/55 first:border-t-0 ` +
        `focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary ${className}`
      }
    >
      <span
        aria-hidden
        className="flex size-[30px] shrink-0 items-center justify-center rounded-[9px] border-[1.5px] border-dashed border-border font-display text-sm font-[650] text-fg-muted"
      >
        ?
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[15px] font-semibold text-fg-secondary">{title}</span>
        <span className="block truncate text-[12.5px] font-medium text-fg-muted">{caption}</span>
      </span>
    </button>
  );
}
